<template lang="pug">
  div.invoice-control.bills-of-waste-generators
    e-toolbar(
      :items="items"
      :hideRemoveButton="true"
      :showTotal="true"
      :showViewPanel="false"
      :hideImportBtn="true"

      :useFilterBtn="true"
      :showFilter="showFilter"
      @closeFilterPanel="onCloseFilterPanel()"
      @openFilterPanel="onOpenFilterPanel()"
    )
      e-form-search-filter(
        slot="filter"
        :formValidator="formValidator"
        v-if="showFilter"
        @apply="applyFilter()"
        @reset="resetFilter()"
      )
        div.one-row

          e-form-group(
            formGroupStyle="filter-block"
            label="Владелец счета"
            inputType="select"
            :model="filterModel"
            tabView="tab1"
            name="owner_id"
            :options="owners"
          )

          e-form-group(
            formGroupStyle="filter-block"
            label="Номер счета"
            validationRule="number"
            :model="filterModel"
            tabView="tab1"
            name="account_number"
          )

          div.filter-block

          e-form-search-filter-buttons(
            :loading="searchInProgress"
          ).filter-block

    e-table(
      :defaultColumnWidth="150"
      :items="items"
      :showCheckbox="false"
      @deleteItem="deleteItem"
      @editItem="editItem"
    )

    router-view
</template>

<script>
  import {invoiceControl, core} from '../../api/api-endpoints.js'
  import tableMixin from "../../components/table/table-mixin.js"
  import url from '../../utils/url.js'

  const FilterModel = () => ({
    owner_id: '',
    account_number: ''
  })

  export default {
    mixins: [tableMixin],
    data () {
      return {
        filterModel: new FilterModel()
      }
    },
    computed: {
      collection () {
        return this.$store.getters.readUrlEndpoint(
          this.getCollectionEndpoint()
        ) || {}
      },
      owners () {
        return []
      }
    },
    methods: {
      getEndpoint (route) {
        return invoiceControl.bankStatements(route)
      },
      getDeleteUrl () {
        console.error('define getDeleteUrl')
        return null
      },
      getCollectionEndpoint() {
        return core.collection('billing_account_status')
      }
    },
    /**
     *
     * @param store
     * @param route
     * @param fromRoute
     * @param methods
     * @returns {Promise<number>|*}
     */
    asyncData ({store, route, fromRoute, methods}) {
      const endpoint = methods.getEndpoint(route, fromRoute)
      // if open modal
      if (fromRoute) {
        let jsonRoute = url.getRoute(fromRoute, true)

        if (route.query.prevRoute && route.query.prevRoute === jsonRoute) {
          // fix: https://redmine.etton.ru/issues/13458
          if (store.getters.readUrlEndpoint(endpoint)) {
            return Promise.resolve(1)
          }
        }
      }

      return Promise.all([
        store.dispatch('updateUrlEndpoint', {
          endpoint,
          params: {
            onMutateError: methods.onMutateError
          }
        }),
        store.dispatch('updateUrlEndpoint', {
          endpoint: methods.getCollectionEndpoint(),
          fromCache: true
        })
      ])
    }
  }
</script>
